import { AvatarTypes, ReportTypes } from '@mode/shared/contract-common';

export enum TableListValueType {
  Avatar = '[TableListCellValue] Avatar',
  Text = '[TableListCellValue] Text',
  Html = '[TableListCellValue] Html',
  Icon = '[TableListCellValue] Icon',
  BadgeWithText = '[TableListCellValue] BadgeWithText',
}

export interface TableListValue {
  type: TableListValueType;
  data: any;
}

export interface TableListTextValue extends TableListValue {
  type: TableListValueType.Text;
  data: string;
}

export interface TableListHtmlValue extends TableListValue {
  type: TableListValueType.Html;
  data: string;
}

export interface TableListIconValue extends TableListValue {
  type: TableListValueType.Icon;
  data: ReportTypes.ReportType;
}

export interface TableListAvatarValue extends TableListValue {
  type: TableListValueType.Avatar;
  data: {
    avatar: AvatarTypes.Avatars | null;
    size: number | null;
  };
}
export interface TableListBadgeWithTextValue extends TableListValue {
  type: TableListValueType.BadgeWithText;
  data: string;
}
